/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {Pipe, PipeTransform} from "@angular/core";
import {AuthLevel} from "../../../../../types/aig/universe";

@Pipe({
	name: "aigauthis",
})

/**
 * Authレベルカラー
 *
 * @since 0.01
 */
export class AIGAuthisPipe implements PipeTransform {

	/**
	 *
	 * @param auth
	 * @param level
	 */
	public transform(auth: number, level: string): boolean {
		let result: boolean = false;     // public
		switch (level) {
			case "system":
				result = (auth <= AuthLevel.system);
				break;
			case "manager":
				result = (auth <= AuthLevel.manager);
				break;
			case "company":
				result = (auth <= AuthLevel.company);
				break;
			case "studio":
				result = (auth <= AuthLevel.studio);
				break;
			case "trainer":
				result = (auth <= AuthLevel.trainer);
				break;
			case "user":
				result = (auth <= AuthLevel.user);
				break;
			case "public":
				result = (auth <= AuthLevel.public);
				break;
			default:
		}
		return result;
	}

}
